// ----------------------------------------------------------------------------
// Component: Icon Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/icon/icon';

// Styles
import './_icon-block.scss';
